import { render, staticRenderFns } from "./page-sales-split-view.vue?vue&type=template&id=7683d00a&scoped=true&"
import script from "./page-sales-split-view.vue?vue&type=script&lang=js&"
export * from "./page-sales-split-view.vue?vue&type=script&lang=js&"
import style0 from "./page-sales-split-view.vue?vue&type=style&index=0&id=7683d00a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7683d00a",
  null
  
)

export default component.exports